import { createSlotRecipe } from './runtime.js';

const tableConfig = {"name":"table","slots":["wrapper","table","overlay","placeholder","empty","scrollLoading","scrollFallback"]}

export const table = /* @__PURE__ */ createSlotRecipe(tableConfig)